import * as React from "react";
import { FieldProps } from "formik";
import { Form, Input } from "antd";

const FormItem = Form.Item;
const { TextArea } = Input;

export const InputField: React.SFC<FieldProps<any> & {
	prefix: React.ReactNode,
	label?: string,
	multiLine: boolean,
	useNumberComponent?: boolean,
	style?: any,
	minRows?: number,
	maxRows?: number,
}> = ({
	prefix,
	field: { onChange, ...field },
	form: { touched, errors, setFieldValue }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
	label,
	useNumberComponent = false,
	multiLine,
	style,
	minRows,
	maxRows,
	...props }) => {
		const errorMessage = touched[field.name] && errors[field.name];
		// const Comp = useNumberComponent ? InputNumber: Input;
		return (
			<FormItem label={label} help={errorMessage} validateStatus={errorMessage ? "error" : undefined}	>
				{multiLine && <TextArea
					{...field}
					{...props}
					style={style}
					autosize={{ minRows, maxRows }}
					onChange={useNumberComponent ? (newValue: any) => setFieldValue(field.name, newValue) : onChange}
				/>}
				{!multiLine && <Input
					prefix={prefix}
					{...field}
					{...props}
					onChange={useNumberComponent ? (newValue: any) => setFieldValue(field.name, newValue) : onChange}
				/>}
			</FormItem>
		);
	};

// export class InputFiel{
// 	render() {
// 	const errorMessage = touched[field.name] && errors[field.name];
// 	const Comp = useNumberComponent ? InputNumber: Input;
// 	return (
// 		<FormItem label={label} help={errorMessage} validateStatus={errorMessage ? "error" : undefined}	>
// 			<Comp 
// 				{...field} 
// 				{...props} 
// 				onChange={useNumberComponent ? (newValue: any) => setFieldValue(field.name, newValue) : onChange}/>
// 		</FormItem>
// 	);
// 	}
// }


// WEBPACK FOOTER //
// ./src/util/InputField.tsx